import axiosInstance from "../Utils/axiosInterceptor";
import {Restaurant} from "../models/Restaurant";
import {MenuItem} from "../models/MenuItem";
import {WorkingHours} from "../models/WorkingHours";
import {Tag} from "../models/Tag";
import {Flavour} from "../models/Flavour";

export class RestaurantService {

    static async getNearestRestaurants(latitude: string | undefined, longitude: string | undefined) {
        try {
            const response = await axiosInstance.get<Restaurant[]>("/get_nearest_restaurants/"+latitude?.toString()+"/"+longitude?.toString());
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async getMenuItemsByRestaurantId(restaurantId: number) {
        try {
            const response = await axiosInstance.get<MenuItem[]>("/get_restaurant_menu_by_restaurant_id/"+restaurantId);
            return response.data;
        } catch (error) {;
            throw error;
        }
    }

    static async getFavourByMenuItemId(id: number) {
        try {
            const response = await axiosInstance.get<Flavour[]>("/get_favour_by_menu_item_id/"+id);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async searchRestaurants(query: string) {
        try {
            const response = await axiosInstance.get<Restaurant[]>("/search_restaurants/"+query);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async getTags() {
        try {
            const response = await axiosInstance.get<Tag[]>("/get_tags/");
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async searchRestaurantsByTagId(latitude: string | undefined, longitude: string | undefined, tag_id: number) {
        try {
            const response = await axiosInstance.get<Restaurant[]>("/search_restaurants_by_tag_id/"+latitude?.toString()+"/"+longitude?.toString()+"/"+tag_id);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async getRestaurantsWorkingHours(restaurants: Restaurant[]) {
        try {
            const response = await axiosInstance.post<WorkingHours[]>("/get_restaurants_working_hours/", restaurants);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static async getWorkingHoursByRestaurant(restaurant: Restaurant) {
        try {
            const response = await axiosInstance.get<WorkingHours[]>('/get_working_hours_by_restaurant/'+restaurant.id);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}